import { BrowserModule } from '@angular/platform-browser';
import { OgDateInputComponent } from './date-input/date-input.component';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { OgHorarioInputComponent } from './horario-input/horario-input.component';
import { MatFormFieldModule, MatInputModule, MatSelectModule } from '@angular/material';
import { CommonModule } from '@angular/common';
import { OgBooleanInputComponent } from './boolean-input/boolean-input.component';
import { DefaultFormErrorsDirective } from './default-form-errors.directive';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    TextMaskModule,
    CommonModule
  ],
  declarations: [
    OgDateInputComponent,
    OgHorarioInputComponent,
    OgBooleanInputComponent,
    DefaultFormErrorsDirective
  ],
  exports: [
    FormsModule,
    OgDateInputComponent,
    OgHorarioInputComponent,
    OgBooleanInputComponent,
    ReactiveFormsModule,
    TextMaskModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    DefaultFormErrorsDirective
  ]
})
export class OgCustomInputsModule { }
